import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import { baseState } from './baseState';
import { baseMutations } from './baseMutations';
import { baseActions } from './baseActions';
import { baseGetters } from './baseGetters';
import { moduleHomePage } from './modules/moduleHomePage';
import { moduleContact } from './modules/moduleContact';

Vue.use(Vuex);

const vuePersist = {
    reducer: state => ({
        moduleHomePage:  state.moduleHomePage,
    }),
    saveState: (key, state, storage) => {
        requestIdleCallback(() => {
            storage.setItem(key, JSON.stringify(state));
        });
    },
};

export default new Vuex.Store({
    plugins: [ createPersistedState(vuePersist) ],
    modules: {
        moduleHomePage: moduleHomePage,
        moduleContact: moduleContact,
    },
    state: baseState,
    mutations: baseMutations,
    actions: baseActions,
    getters: baseGetters,
});